// import external dependencies

import "jquery"

// Import everything from autoload
import "./autoload/_bootstrap.js"
import customerArea from "./modules/customer-area";
import videoPlay from "./modules/video-play";
import { initSliders } from "./modules/slider";
import cookieBar from "./modules/cookie-bar";
import selectPlaceholder from "./modules/select-placeholder";
import navMobile from "./modules/nav-mobile";
import { dowmloadFileForm } from "./modules/form-submision";
import { initFormEvents } from "./modules/forms";
import waveWidth from "./modules/wave-width";

jQuery(document).ready(() => {
	// to top right away
	if ( window.location.hash ) scroll(0,0);
// void some browsers issue
	setTimeout( function() { scroll(0,0); }, 1);

	$(function() {
		// *only* if we have anchor on the url
		if(window.location.hash) {
			// smooth scroll to the anchor id
			setTimeout(function () {
				$('html, body').animate({
					scrollTop: $(window.location.hash).offset().top + 'px',
				}, 1000, 'swing');
			}, 100);
		}
	});
});

document.addEventListener("DOMContentLoaded", () => {
	navMobile();
	customerArea();
	videoPlay();
	selectPlaceholder();

	// download file form
	dowmloadFileForm();

	// init sliders
	initSliders();

	// init forms events
	initFormEvents();
});

window.addEventListener("load", () => {
	cookieBar();
	waveWidth();
});



// WEBPACK FOOTER //
// ./scripts/main.js